/**
 * Takes a value and returns a deep clone of that value.
 *
 * ```ts
 * const a = { x: { y: 1 } };
 * const b = a.x;
 * const c = tt.clone(a);
 * const d = c.x;
 * // a !== c
 * // b !== d
 * ```
 *
 * @param a The value to clone.
 */
export function deepClone<A>(a: A): A {
  try {
    return JSON.parse(JSON.stringify(a));
  } catch (e) {
    console.error(`tt.deepClone:`, e);
    return a;
  }
}
